import { Picture, RichText, Text } from "@kvix/ui";
import { Box, makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import React, { useState } from "react";
import { Person as PersonType } from "./Person";

interface PersonListInterface {
  title: string;
  people: PersonType[];
  noMargin?: boolean;
}

export const fadeColor = (color: string) => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
  return `${parseInt(result![1], 16)},${parseInt(result![2], 16)},${parseInt(
    result![3],
    16
  )}`;
};

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: (props: any) => (props.noMargin ? 0 : theme.spacing(6)),
    "& h3": {
      marginTop: 40,
      marginBottom: 20,
    },
  },
  row: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",

    [theme.breakpoints.up("sm")]: {
      justifyContent: (props: any) => props.justifyContent || "unset",
    },
  },
  person: {
    padding: 6,
  },
  image: {
    margin: "12px 24px 12px 0px",
  },
  personText: {
    with: "100%",
    "& .MuiTypography-root": {
      fontSize: "14px !important",
    },
    "& h4": {
      marginTop: 24,
      marginBottom: 12,
    },
    [theme.breakpoints.up("sm")]: {
      width: 246,
    },
  },
  toggle: {
    cursor: "pointer",
    textDecoration: "underline",
    margin: "24px 0 24px",
  },
  richText: {
    position: "relative",
    overflow: "hidden",
    maxHeight: ({ showRichText }: any) => (showRichText ? "100%" : 120),
  },
  textFade: {
    width: "100%",
    height: 120,
    position: "absolute",
    bottom: 0,
    zIndex: 10,
    backgroundImage: ({ fadeColor }: any) =>
      `linear-gradient(to bottom, rgba(${fadeColor}, 0), rgba(${fadeColor}, 1))`,
  },
}));

export const TextFade: React.FC<{ fadeColor: string }> = (props) => {
  const classes = useStyles(props);
  return <Box className={classes.textFade} />;
};

const Person: React.FC<PersonType> = (props) => {
  const [showRichText, setShowRichText] = useState(false);
  const { name, image, jobTitle, info } = props;
  const theme = useTheme();
  const classes = useStyles({
    ...props,
    showRichText,
  });
  const isMobile = useMediaQuery(theme.breakpoints.down(400));

  return (
    <div>
      <Picture
        width={isMobile ? "100%" : 220}
        height={330}
        className={classes.image}
        imageUrl={image.url}
        borderRadius
      />
      <div className={classes.personText}>
        <Text variant="h4">{name}</Text>
        <Box marginBottom={4}>
          <Text variant="caption">{jobTitle}</Text>
        </Box>
        <div className={classes.richText}>
          <RichText text={info} noPadding />
          {!showRichText && (
            <TextFade fadeColor={fadeColor(theme.palette.background.default)} />
          )}
        </div>
        <span
          tabIndex={0}
          onClick={() => setShowRichText(!showRichText)}
          className={classes.toggle}
        >
          {showRichText ? "Fäll ihop" : "Visa mer"}
        </span>
      </div>
    </div>
  );
};

export const PersonList: React.FC<PersonListInterface> = (props) => {
  const { title, people } = props;
  const classes = useStyles(props);

  return (
    <div className={classes.root}>
      <Text variant="h3">{title}</Text>
      <div className={classes.row}>
        {people.map((person, index) => {
          return (
            <div key={index} className={classes.person}>
              <Person {...person} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PersonList;
